<template>
  <div>

    <div class="has-text-centered mb-6" v-if="init.name || init.subname">
      <h1 v-if="init.name" class="title is-3">{{init.name}}</h1>
      <h2 v-if="init.subname" class="subtitle is-5" style="white-space: pre-wrap;">{{init.subname}}</h2>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'files'}" @click="tabActive = 'files'" v-if="implant._id">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="folder" /></span>
            <span>Documenti</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'history'}" @click="tabActive = 'history'" v-if="implant._id">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="clock-rotate-left" /></span>
            <span>Storico</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">

        <ImplantInfo v-model:implant="implant" :clients="clients" @openNewOccupant="openNewOccupant()" @openNewClient="openNewClient()" @editPlace="editPlace()" @openNewPlace="openNewPlace()" @openAppointment="openAppointment($event)" />

      </div>
    </transition>

    <transition name="fade" mode="out-in" v-if="implant._id">
      <div v-show="tabActive === 'files'">

        <FileList :id="implant._id" type="implant" />

      </div>
    </transition>

    <transition name="fade" mode="out-in" v-if="implant._id">
      <div v-show="tabActive === 'history'">
        <Timeline entity="implant" :id="implant._id" />
      </div>
    </transition>

    <AppointmentCalendar :deadline="deadline" :open="openModalAppointment" @close="this.openModalAppointment = false" @saved="$router.push('/appuntamenti/' + $event)" />

    <Modal :title="newType === 'client' ? 'Crea nuovo proprietario' : 'Crea nuovo occupante'" :openModal="openNewModal" @close="openNewModal = false" @success="saveClient()" :loading="disabledClientSave">
      <div class="columns is-multiline">
        <div class="column is-12">
          <label class="checkbox">
            <input type="checkbox" v-model="newClient.sameForPlace">
            Crea luogo con stesso indirizzo
          </label>
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Nome" v-model="newClient.name" :required="true" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Cognome" v-model="newClient.surname" :required="true" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Ragione sociale" v-model="newClient.business_name" :required="true" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Indirizzo" v-model="newClient.address" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="CAP" v-model="newClient.zip" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Città" v-model="newClient.city" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-2-desktop">
          <InputText name="Provincia" v-model="newClient.province" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Codice fiscale" v-model="newClient.cf" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Partita IVA" v-model="newClient.vat" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="SDI" v-model="newClient.sdi" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="PEC" v-model="newClient.pec" type="email" />
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <InputText name="Email" v-model="newClient.email" type="email" />
        </div>
        <div class="column is-12 p-0"></div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <div class="box">
            <InputText name="Nome contatto" v-model="newClient.contacts[0].name" />
            <InputText name="Telefono" v-model="newClient.contacts[0].telephone" type="tel" />
          </div>
        </div>
        <div class="column is-12 p-0"></div>
        <div class="column is-12">
          <InputTextarea name="Note" v-model="newClient.notes" />
        </div>
      </div>
    </Modal>

    <Modal :title="'Modifica indirizzo'" :openModal="openEditPlace" @close="openEditPlace = false" @success="saveEditPlace()" :disabled="!editPlaceType || ((editPlaceType === 'new' && !editPlaceForm.address) || (editPlaceType === 'exist' && !editPlaceForm.selectedPlaceId))">
      <div class="columns is-multiline">
        <div class="column is-12 has-text-centered">
          <b>Attenzione:</b> è un luogo nuovo oppure già esiste?
        </div>

        <div class="column is-12 has-text-centered">
          <b>Associa il luogo a:</b>
        </div>

        <div class="column is-12 is-flex is-justify-content-center is-align-items-center">
          <div class="buttons">
            <button class="button" type="button" @click="setEditPlaceOwnerType('client')" :class="{'is-primary': editPlaceOwnerType === 'client'}">Proprietario</button>
            <button class="button" type="button" @click="setEditPlaceOwnerType('occupant')" :class="{'is-primary': editPlaceOwnerType === 'occupant'}">Occupante</button>
          </div>
        </div>

        <div class="column is-12 is-flex is-justify-content-center is-align-items-center">
          <div class="buttons">
            <button class="button" type="button" @click="editPlaceType = 'new'">Nuovo</button>
            <button class="button" type="button" @click="editPlaceType = 'exist'">Esistente</button>
          </div>
        </div>
        <div class="column is-12" v-if="editPlaceType === 'new'">
          <div class="columns is-multiline">
            <div class="column is-12">
              Il luogo verrà assegnato a <b>{{ editPlaceOwnerType === 'client' ? 'proprietario' : 'occupante' }}</b>
            </div>
            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Indirizzo" v-model="editPlaceForm.address" />
            </div>
            <div class="column is-6-mobile is-3-tablet">
              <InputText name="Piano" v-model="editPlaceForm.floor" />
            </div>
            <div class="column is-6-mobile is-3-tablet">
              <InputText name="Interno" v-model="editPlaceForm.interior" />
            </div>
            <div class="column is-12-mobile is-4-tablet">
              <InputText name="CAP" v-model="editPlaceForm.zip" />
            </div>
            <div class="column is-12-mobile is-8-tablet">
              <InputText name="Città" v-model="editPlaceForm.city" />
            </div>
            <div class="column is-12-mobile is-4-tablet">
              <InputText name="Provincia" v-model="editPlaceForm.province" />
            </div>

            <div class="column is-12 p-0"></div>

            <div class="column is-12-mobile">
              <InputTextarea name="Note" v-model="editPlaceForm.notes" />
            </div>
          </div>
        </div>

        <div class="column is-12" v-if="editPlaceType === 'exist'">
          <div class="columns is-multiline">
            <div class="column is-12">
              <InputSelect
                :name="editPlaceOwnerType === 'client' ? 'Luogo proprietario' : 'Luogo occupante'"
                v-model="editPlaceForm.selectedPlaceId"
                :options="editPlaceOwnerType === 'client' ? places : places_occupant"
                id="_id"
                track-by="_id"
                :custom-label="$placeName"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
      return {
        implant: {
          codes: [],

          generator_thermals: [],
          generator_burners: [],
          generator_recoverers: [],
          generator_pumps: [],
          generator_exchangers: [],
          generator_cogenerators: [],
          generator_solars: [],
          generator_others: [],

          regulation_systems: [],
          regulating_valves: [],
          valves: [],

          expansion_vessels: [],
          pumps: [],

          accumulations: [],

          other_towers: [],
          other_coolers: [],
          other_exchangers: [],
          other_circuits: [],
          other_units: [],
          other_recoverers: [],

          ventilation_systems: []
        },

        clients: [],
        places: [],
        places_occupant: [],

        tabActive: 'info',

        waitRecord: true,
        waitClients: true,
        waitPlaces: false,

        disabledSave: false,

        openModalAppointment: false,
        deadline: {},

        init: {
          name: false,
          subname: false
        },

        openNewModal: false,
        disabledClientSave: false,
        newClient: {
          contacts: [{}],
          sameForPlace: false
        },

        newType: false,

        openImplantModal: false,
        findImplant: {
          list: {
            clients: [],
            places: [],
            implants: []
          }
        },
        waitImplants: false,

        openEditPlace: false,
        editPlaceForm: {},
        editPlaceType: false,
        editPlaceOwnerType: 'occupant'
      }
  },

  methods: {
    normalizeProvinceCode(value) {
      return (value || '').toString().replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)
    },

    checkRequired() {
      if (!this.implant.client) {
        alert('Proprietario obbligatorio!')
        return false
      }
      if (!this.implant.occupant) {
        alert('Occupante obbligatorio!')
        return false
      }
      if (!this.implant.place_occupant) {
        alert('Luogo obbligatorio!')
        return false
      }

      return true
    },

    saveImplant() {
      if (!this.checkRequired()) {
        return false
      }

      const self = this
      this.disabledSave = true

      this.$http.post('/implant', this.implant)
      .then(function (response) {
        utils.deleteDraft(self, self.implant._timestamp, 'implant').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/impianti/' + createdId)
          } else {
            self.$router.push('/impianti')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateImplant() {
      const self = this
      this.disabledSave = true

      this.$http.put('/implant/' + this.implant._id, this.implant)
      .then(function (response) {
        utils.deleteDraft(self, self.implant._timestamp, 'implant').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    getPlaces(client, type) {
      const self = this
      self.waitPlaces = true

      this.$http.get('/place', { params: {page: 1, size: -1, client: client._id} })
      .then(function (response) {
        if (response && response.data) {
          const records = response.data.records
          if (type === 'client') {
            self.places = records
          } else if (type === 'occupant') {
            self.places_occupant = records
          } else if (type === 'findImplant') {
            self.findImplant.list.places = records
          }

          if (records.length === 1) {
            if (type === 'client') {
              self.implant.place = records[0]
            } else if (type === 'occupant') {
              self.implant.place_occupant = records[0]
            } else if (type === 'findImplant') {
              self.findImplant.place = records[0]
              self.changePlaceFindImplant(records[0])
            }
          }
        }
        self.waitPlaces = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changeOccupant(occupant) {
      if (this.implant._id) {
        return
      }
      this.implant.place_occupant = null

      this.getPlaces(occupant, 'occupant')
    },

    removeOccupant(occupant) {
      this.implant.place_occupant = null
    },

    openAppointment(revision) {
      console.log(revision)
      const foundType = this.$store.state.revision_types.find((type, typeIndex) => type.name === revision.type)

      this.deadline = {
        client: this.implant.client,
        occupant: this.implant.occupant,
        place_occupant: this.implant.place_occupant,
        system: this.implant,
        _id: revision._id,
        reception_date: new Date().toDateInputValue(),
        stamp: (foundType && foundType.stamp)
      }
      this.openModalAppointment = true
    },

    openNewClient() {
      this.newType = 'client'
      this.openNewModal = true
    },

    openNewOccupant() {
      this.newType = 'occupant'
      this.openNewModal = true
    },

    saveClient() {
      if (!(this.newClient.business_name || (this.newClient.name && this.newClient.surname))) {
        alert('Sono obbligatori nome e cognome oppure la ragione sociale!')
        return false
      }

      this.newClient.province = this.normalizeProvinceCode(this.newClient.province)

      const self = this
      this.disabledClientSave = true

      this.$http.post('/client', this.newClient)
      .then(function (response) {
        if (self.newType === 'client') {
          self.implant.client = response.data
        } else if (self.newType === 'occupant') {
          self.implant.occupant = response.data
        }

        self.getClients(true)

        if (self.newClient.sameForPlace) {
          self.$http.post('/place', {
            client: response.data,
            address: self.newClient.address,
            zip: self.newClient.zip,
            city: self.newClient.city,
            province: self.newClient.province
          })
            .then(function (response) {
              if (self.newType === 'client') {
                self.implant.place = response.data
              } else if (self.newType === 'occupant') {
                self.implant.place_occupant = response.data
              }

              self.disabledClientSave = false
              self.openNewModal = false

              self.newClient = {
                contacts: [{}],
                sameForPlace: true
              }
            })
            .catch(function (error) {
              console.log(error)
              alert('Errore')
              self.disabledClientSave = false
            })
        } else {
          self.disabledClientSave = false
          self.openNewModal = false

          self.newClient = {
            contacts: [{}],
            sameForPlace: true
          }
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledClientSave = false
      })
    },

    addElement(index) {
      if (!this.implant[index]) {
        this.implant[index] = []
      }
      this.implant[index].push({})
    },

    getClients(force = false) {
      const self = this

      utils.fetchClients(this.$http, force)
      .then(function (clients) {
        self.clients = clients
        self.findImplant.list.clients = clients
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changeClientFindImplant(client) {
      this.findImplant.place = null

      this.getPlaces(client, 'findImplant')
    },

    changePlaceFindImplant(place) {
      this.findImplant.implant = null

      this.getImplants(place)
    },

    getImplants(place) {
      const self = this
      self.waitImplants = true

      this.$http.get('/implant', { params: {page: 1, size: -1, place_id: place._id} })
      .then(function (response) {
        if (response && response.data) {
          self.findImplant.list.implants = response.data.records

          if (self.findImplant.list.implants.length === 1) {
            self.findImplant.implant = self.findImplant.list.implants[0]
          }
        }
        self.waitImplants = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    addImplant() {
      this.implant.linked_implants.push(this.findImplant.implant)

      this.findImplant.occupant = null
      this.findImplant.place = null
      this.findImplant.implant = null

      this.openImplantModal = false
    },

    editPlace() {
      this.editPlaceForm = {}
      this.editPlaceType = false
      this.editPlaceOwnerType = this.implant.occupant ? 'occupant' : 'client'

      if (this.implant.client) {
        this.getPlaces(this.implant.client, 'client')
      }
      if (this.implant.occupant) {
        this.getPlaces(this.implant.occupant, 'occupant')
      }

      this.openEditPlace = true
    },

    openNewPlace() {
      this.editPlaceForm = {}
      this.editPlaceType = 'new'
      this.editPlaceOwnerType = this.implant.occupant ? 'occupant' : 'client'

      if (this.implant.client) {
        this.getPlaces(this.implant.client, 'client')
      }
      if (this.implant.occupant) {
        this.getPlaces(this.implant.occupant, 'occupant')
      }

      this.openEditPlace = true
    },

    setEditPlaceOwnerType(type) {
      this.editPlaceOwnerType = type
      this.editPlaceForm.selectedPlaceId = null

      if (type === 'client' && this.implant.client) {
        this.getPlaces(this.implant.client, 'client')
      }
      if (type === 'occupant' && this.implant.occupant) {
        this.getPlaces(this.implant.occupant, 'occupant')
      }
    },

    async saveEditPlace() {
      if (confirm('Siamo sicuri sicuri? 🧐')) {
        const self = this

        let id_place = false
        let selectedPlace = null
        if (this.editPlaceType === 'new') {
          const ownerId = this.editPlaceOwnerType === 'client' ? this.implant.client?._id : this.implant.occupant?._id
          if (!ownerId) {
            alert('Seleziona prima il ' + (this.editPlaceOwnerType === 'client' ? 'proprietario' : 'occupante'))
            return
          }

          this.editPlaceForm.province = this.normalizeProvinceCode(this.editPlaceForm.province)
          this.editPlaceForm.client = ownerId
          await this.$http.post('/place', this.editPlaceForm)
            .then(function (response) {
              id_place = response.data._id
              selectedPlace = response.data
            })
            .catch(function (error) {
              console.log(error)
              alert('Errore')
            })
        } else if (this.editPlaceType === 'exist') {
          const selectedPlaceId = this.editPlaceForm.selectedPlaceId
          id_place = selectedPlaceId?._id || selectedPlaceId

          const sourcePlaces = this.editPlaceOwnerType === 'client' ? this.places : this.places_occupant
          selectedPlace = sourcePlaces.find(place => place._id === id_place) || null
        }

        if (!id_place) {
          return
        }

        if (!this.implant._id) {
          this.implant.place_occupant = selectedPlace || { _id: id_place }
          self.editPlaceForm = {}
          self.editPlaceType = false
          self.openEditPlace = false
          return
        }

        this.$http.post('/implant/' + this.implant._id + '/change-place', { id_place })
          .then(function (response) {
            if (response && response.data) {
              self.editPlaceForm = {}
              self.editPlaceType = false

              self.openEditPlace = false

              location.reload()
            }
          })
          .catch(function (error) {
            console.log(error)
            alert('Errore')
          })
      }
    }
  },

  watch: {
    implant: {
      handler(value) {
        utils.prepareDraft(this, this.implant, value, 'implant')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/implant/' + id)
      .then(function (response) {
        self.implant = response.data

        self.init.subname = utils.implantName(self.implant)

        if (self.implant.client) {
          if (self.implant.client.business_name) {
            self.init.name = self.implant.client.business_name
          } else {
            self.init.name = self.$fullname(self.implant.client)
          }
        }
        self.waitRecord = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      self.waitRecord = false

      if (this.$store.getters.getForm('implant')) {
        self.implant = this.$store.getters.getForm('implant')
      }
    }

    this.getClients()
  }
}
</script>